import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './css/WelcomeMessage.css';
import { Tooltip } from 'react-tooltip';

import InfoIcon from '@mui/icons-material/Info';

function OptionsPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const {firmName, selectedCurrency, firmId, accountId, email } = location.state;

    const [selectedOption, setSelectedOption] = useState('');

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const handleNext = () => {
        if (selectedOption === 'createOpportunity') {
            navigate('/create-opportunity', {
                state: { firmName, selectedCurrency, firmId, accountId, email }
            });
        } else if (selectedOption === 'option2') {
            navigate('/createUserCopy', {
                state: { firmName, selectedCurrency, firmId, accountId, email }
            });
        } else if (selectedOption === 'option3') {
            navigate('/createUserLayout', {
                state: { firmName, selectedCurrency, firmId, accountId, email }
            });
        } else if (selectedOption === 'option4') {
            navigate('/connections', {
                state: { firmName, selectedCurrency, firmId, accountId , email}
            });
        
        } else if (selectedOption === 'option5') {
            navigate('/copyUserLayout', {
                state: { firmName, selectedCurrency, firmId, accountId, email }
            });
        }
    };

    return (
        <div>
                {/* <Link
            to={{
                pathname: "/billingEntity",
                state: { 
                        selectedEntity,
                        firmName,
                        currency,
                        firmId,
                        accountId 
                },
                }}
                className="back-link"
                >
                Back
            </Link> */}

<button
    onClick={() => {
        navigate('/currencyPage', {
            state: { 
                firmName,
                selectedCurrency,
                firmId,
                accountId, 
                email
            }
        });
    }}
    className="back-link"
>
    Back
</button>
           
            <div className="opportunity-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img 
                    src="https://cloud9requests.symphony.com/Cloud9_Logo.png" 
                    alt="C9 Logo" 
                    width="300" 
                    height="100"
                />
                <h2>Firm Name : {firmName}!</h2>
                {/* <p><strong>Selected Billing Entity: {selectedEntity?.Name}</strong><br/> */}
                <p><strong>Selected Currency:</strong> {selectedCurrency}</p>
               
                
                <h2>Select an Option</h2>
                <div style={{ marginTop: '20px' }}>
                <label id="tooltip-createOpportunity">
                        <input 
                            type="radio" 
                            value="createOpportunity" 
                            checked={selectedOption === 'createOpportunity'} 
                            onChange={handleOptionChange} 
                        />
                        New User Request
                        <span className="info-icon" data-tooltip-id="tooltip-createOpportunity">
                        <InfoIcon className="info-icon" />
                        </span>
                        <Tooltip
                            id="tooltip-createOpportunity"
                            content="Create a new user for your firm."
                            place="top"
                        />
                    </label>
                    <br />
                    <label id="tooltip-option2">
                        <input 
                            type="radio" 
                            value="option2" 
                            checked={selectedOption === 'option2'} 
                            onChange={handleOptionChange} 
                        />
                       New User Request - Copy Settings from Existing User
                        <InfoIcon
                            className="info-icon"
                            data-tooltip-id="tooltip-option2"
                        />
                        <Tooltip
                            id="tooltip-option2"
                            content="This option is to create a new Users and new users will have the same Address, Settings, Recording Options, Groups and Neighbors as an existing user."
                            place="top"
                        />
                    </label>
                    <br />
                    <label id="tooltip-option3">
                        <input 
                            type="radio" 
                            value="option3" 
                            checked={selectedOption === 'option3'} 
                            onChange={handleOptionChange} 
                        />
                        New User Request - Copy Settings and Copy Layout from Existing User
                        <InfoIcon
                            className="info-icon"
                            data-tooltip-id="tooltip-option3"
                        />
                        <Tooltip
                            id="tooltip-option3"
                            content="This option is to create new Users and new users will have the same Address, Settings, Recording Options, Groups, Neighbors AND CONNECTIONS as an existing user."
                            place="top"
                        />
                    </label>
                    <br />
                    <label id="tooltip-option5">
                        <input 
                            type="radio" 
                            value="option5" 
                            checked={selectedOption === 'option5'} 
                            onChange={handleOptionChange} 
                        />
                        User Layout Copy

                        <InfoIcon
                            className="info-icon"
                            data-tooltip-id="tooltip-option5"
                        />
                        <Tooltip
                            id="tooltip-option5"
                            content="User Layout Copy - Includes replication of Groups, Shoutdowns, Ringdowns and User Layout. Cloud Dial Tone copy on demand."
                            place="top"
                        />
                    </label>
                    <br />
                    <label id="tooltip-option4">
                        <input 
                            type="radio" 
                            value="option4" 
                            checked={selectedOption === 'option4'} 
                            onChange={handleOptionChange} 
                        />
                        New C9-C9 Connection Request.

                        <InfoIcon
                            className="info-icon"
                            data-tooltip-id="tooltip-option4"
                        />
                        <Tooltip
                            id="tooltip-option4"
                            content="Select this option for a new Cloud9 to Cloud9 connection, and covers both internal or external connections. For new SIP NNI Private Wires, work with your circuit vendor directly, who will provide us with the circuit details once available"
                            place="top"
                        />
                    </label>
                </div>
                <Tooltip effect="solid" place="right" />
                <button 
                    onClick={handleNext} 
                    disabled={!selectedOption} 
                    style={{ marginTop: '20px' }}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default OptionsPage;
